import { OnboardingButton } from 'components/onboarding/components/DefaultButton';
import { useTranslation } from 'hooks/useTranslation';
import React, { Fragment, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import getFirstNode from 'utils/getFirstNode';
import { getRegion } from 'utils/Region';
import { redirectToAppStore } from './utils';

export const OTP_CONFIRM_TRANSLATION_KEYS = {
  TITLE: {
    key: 'Onboarding2_VinculacionOTP_Texto_Titulo_VinculacionCorrecta',
  },
  BLOCK1_TEXT1: {
    key: 'Onboarding2_VinculacionOTP_Texto_Parrafo1_Parte1',
    length: 40,
  },
  BLOCK1_TEXT2: {
    key: 'Onboarding2_VinculacionOTP_Texto_Parrafo1_Parte2',
  },
  BLOCK2_TEXT1: {
    key: 'Onboarding2_VinculacionOTP_Texto_Parrafo2_Parte1',
  },
  BLOCK2_TEXT2: {
    key: 'Onboarding2_VinculacionOTP_Texto_Parrafo2_Parte2',
  },
  DEEPLINK_TXT: {
    key: 'Onboarding2_Boton_Texto_DescargaLaApp',
  },
  CLOSE: {
    key: 'Onboarding2_VinculacionOTP_Enlace_Texto_CerrarSesion',
  },
};

export const OtpConfirmation = ({ isMobile }) => {
  const navigate = useNavigate();
  const { translationMapper } = useTranslation();
  const {
    Onboarding2_VinculacionOTP_Icono_VinculacionCorrecta = '',
  } = useSelector(state => state.asset);

  const translatedTexts = useMemo(
    () => translationMapper(OTP_CONFIRM_TRANSLATION_KEYS),
    [],
  );

  return (
    <Fragment>
      <img
        className="AppAuthConfirmModal__Content__Icon"
        src={Onboarding2_VinculacionOTP_Icono_VinculacionCorrecta}
        alt="otp-success"
      />
      <h2 className={'AppAuthConfirmModal__Content__Title'}>
        {translatedTexts.TITLE}
      </h2>
      <p className="AppAuthConfirmModal__Content__Block1">
        {translatedTexts.BLOCK1_TEXT1}
        <br />
        {translatedTexts.BLOCK1_TEXT2}
      </p>
      <p className="AppAuthConfirmModal__Content__Block2">
        {translatedTexts.BLOCK2_TEXT1}
        <br />
        {translatedTexts.BLOCK2_TEXT2}
      </p>
      <div className="AppAuthConfirmModal__Content__AppButton">
        {isMobile && (
          <OnboardingButton
            textContent={translatedTexts.DEEPLINK_TXT}
            size="large"
            variant="secondary"
            className="AppAuthConfirmModal__Content__AppButton__Download"
            onClick={redirectToAppStore}
          />
        )}
      </div>
      <button
        className={'AppAuthConfirmModal__Content__Button'}
        onClick={() =>
          navigate(`/${getRegion()}/landing`, { replace: true })
        }
      >
        {translatedTexts.CLOSE}
      </button>
    </Fragment>
  );
};
